import ButtonWithIcon from './ButtonWithIcon'
import VsModal from './VsModal'
import VsTable from './VsTable'
import VsPager from './VsPager'

export default function (vueObject) {
  vueObject.component('button-with-icon', ButtonWithIcon)
  vueObject.component('vs-modal', VsModal)
  vueObject.component('vs-table', VsTable)
  vueObject.component('vs-pager', VsPager)
}
